import __request__ from "routing/request";
export function getList(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/authz/roles", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getListForUser(sort = "name", username, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/authz/roles/user/${username}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(roleId, requestOptions) {
  return __request__("GET", `/authz/roles/${roleId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(roleId, requestOptions) {
  return __request__("DELETE", `/authz/roles/${roleId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeUser(roleId, username, requestOptions) {
  return __request__("DELETE", `/authz/roles/${roleId}/assignee/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addUser(roleId, usernames, requestOptions) {
  return __request__("PUT", `/authz/roles/${roleId}/assignees`, usernames, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getUsersForRole(sort = "name", roleId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/authz/roles/${roleId}/assignees`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
